import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogTrigger,
} from '@/component/ui/dialog'
import { Button, ZyguanbiTianchongIcon, ZyxinxiTianchongIcon } from '@/component'
import { useState } from 'react'
import { cn } from '@/lib/utils'

interface ConfirmDialogProps {
  children?: React.ReactNode
  title: string
  description?: string | React.ReactNode
  onConfirm: () => Promise<void> | void
  onCancel?: () => void
  confirmText?: string
  cancelText?: string
  open?: boolean
  onOpenChange?: (open: boolean) => void
  type?: 'confirm' | 'delete'
  mask?: boolean
  dialogClassName?: string
}

export function ConfirmDialog({
  title,
  description = '',
  onConfirm,
  onCancel,
  confirmText = '确定',
  cancelText = '取消',
  open: controlledOpen,
  onOpenChange,
  children,
  type = 'confirm',
  mask = true, //是否显示遮罩
  dialogClassName, //弹窗样式
}: ConfirmDialogProps) {
  const [loading, setLoading] = useState(false)
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false)

  const isControlled = controlledOpen !== undefined
  const open = isControlled ? controlledOpen : uncontrolledOpen
  const setOpen = isControlled ? (onOpenChange ?? (() => {})) : setUncontrolledOpen

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await onConfirm()
    } finally {
      setLoading(false)
      setOpen(false)
    }
  }

  const handleCancel = () => {
    setOpen(false)
    onCancel?.()
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className={cn('p-8 pt-7', dialogClassName)} closeClassName="top-4.5 right-4.5" mask={mask}>
        <DialogHeader className="gap-4 border-0">
          <DialogTitle className="flex items-center gap-2">
            {
              {
                confirm: <ZyxinxiTianchongIcon className="text-warning" size={24} />,
                delete: <ZyguanbiTianchongIcon className="text-danger" size={24} />,
              }[type]
            }
            {title}
          </DialogTitle>
          <DialogDescription className="text-legend ml-8">{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="border-0 m-0 p-0">
          <Button className="w-20" variant="secondary" onClick={handleCancel}>
            {cancelText}
          </Button>
          <Button className="w-20" onClick={handleConfirm} disabled={loading}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
